import { useMemo } from 'react'

import { type TravelDistanceItem, updateTravelDistance } from '../../models/user'
import { applyServerErrors } from './formServerErrors'
import { type SaveResult, type SyncedForm, useSyncedForm } from './useSyncedForm'

export interface TravelDistanceValues {
  travelDistance: string[]
}

export interface TravelDistanceForm extends SyncedForm<TravelDistanceValues> {
  save: (orgId: string, options: { onlyChanged: boolean }) => Promise<SaveResult>
}

const ERROR_FIELDS = { travel_distance: 'travelDistance' } as const

export function useTravelDistanceForm(selected: TravelDistanceItem[] | null | undefined): TravelDistanceForm {
  const values = useMemo(() => ({ travelDistance: selected?.map((item) => item.value) ?? [] }), [selected])
  const synced = useSyncedForm(values)

  async function save(orgId: string, { onlyChanged }: { onlyChanged: boolean }): Promise<SaveResult> {
    const { form, changedFields, markSaved } = synced
    form.clearErrors()
    if (onlyChanged && changedFields.length === 0) return { ok: true }
    try {
      await updateTravelDistance(orgId, form.getValues('travelDistance'))
      markSaved()
      return { ok: true }
    } catch (error) {
      applyServerErrors(form, error, ERROR_FIELDS)
      return { ok: false, error }
    }
  }

  return { ...synced, save }
}
